import { 
  collection,
  getDocs,
  query,
  updateDoc,
  doc,
  deleteField,
  runTransaction
} from 'firebase/firestore';
import { db } from '../config';

// Migrate existing features to predictions format
export const migrateFeaturesToPredictions = async () => {
  try {
    // Get all media docs
    const mediaQuery = query(collection(db, 'site_media'));
    const mediaSnap = await getDocs(mediaQuery);

    // Process each media document
    const updatePromises = mediaSnap.docs.map(async (mediaDoc) => {
      const data = mediaDoc.data();
      if (!data.features) return; // Skip if no features

      // Convert features to predictions
      const predictions = [];
      Object.entries(data.features).forEach(([featureId, feature]) => {
        if (feature.enabled) {
          predictions.push({
            class: feature.label || featureId,
            confidence: feature.confidence || 1,
            source: feature.autoDetected ? 'auto' : 'system',
            x: feature.bbox?.x || 0,
            y: feature.bbox?.y || 0,
            width: feature.bbox?.width || 0,
            height: feature.bbox?.height || 0
          });
        }
      });

      // Update media doc - add predictions and remove features
      return updateDoc(doc(db, 'site_media', mediaDoc.id), {
        predictions,
        features: deleteField()
      });
    });

    await Promise.all(updatePromises);

    // Update all sites to use new feature format
    const sitesQuery = query(collection(db, 'sites'));
    const sitesSnap = await getDocs(sitesQuery);

    for (const siteDoc of sitesSnap.docs) {
      const siteRef = doc(db, 'sites', siteDoc.id);
      
      await runTransaction(db, async (transaction) => {
        // Get all media for this site
        const mediaQuery = query(
          collection(db, 'site_media'),
          where('siteId', '==', siteDoc.id)
        );
        const mediaSnap = await getDocs(mediaQuery);
        
        // Aggregate predictions from all media into features
        const aggregatedFeatures = {};
        mediaSnap.docs.forEach(doc => {
          const mediaPredictions = doc.data().predictions || [];
          mediaPredictions.forEach(pred => {
            const featureId = pred.class;
            if (!aggregatedFeatures[featureId]) {
              aggregatedFeatures[featureId] = {
                enabled: true,
                autoDetected: pred.source !== 'manual',
                confidence: pred.confidence || 1,
                label: featureId
              };
            } else if (pred.confidence) {
              aggregatedFeatures[featureId].confidence = Math.max(
                aggregatedFeatures[featureId].confidence || 0,
                pred.confidence
              );
            }
          });
        });

        // Update site with aggregated features
        transaction.update(siteRef, {
          features: aggregatedFeatures
        });
      });
    }

    return { success: true };
  } catch (error) {
    console.error('Error migrating features to predictions:', error);
    return { 
      success: false, 
      error: 'Failed to migrate features to predictions' 
    };
  }
};
